// Port of api/fuel/app/classes/filter/search/games/filters/query/rating/user/rating.php
import F from 'offline/filter/constants'
import Util from 'offline/util'
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'rating.user.rating',
	priority: 65,
	require: function(config, filter) {
		return rangeActive(filter.rating && filter.rating.user, 0, 10)
	},
	run: function(config, filter, data, query) {
		var alias = 'r'
		if (config.ownerType !== F.OWNER_USER && config.resultType !== F.RESULT_RATING) {
			alias = 'ru'
			query.rename('r', 'ru')
		}
		if (filter.rating.user.from > 0) {
			query.where(alias + '.rating_value', '>=', Util.adjustedRating(filter.rating.user.from))
		}
		if (filter.rating.user.to < 10) {
			query.where(alias + '.rating_value', '<=', Util.adjustedRating(filter.rating.user.to, true))
		}
		if (config.userID) {
			query.where(alias + '.user_id', '=', config.userID)
		}
	}
}
